var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H28C32.4183 0 36 3.58172 36 8V28C36 32.4183 32.4183 36 28 36H8C3.58172 36 0 32.4183 0 28V8Z",
    fill: "#D4EDDA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 27C17.3 27 16.7083 26.7583 16.225 26.275C15.7417 25.7917 15.5 25.2 15.5 24.5C15.5 23.8 15.7417 23.2083 16.225 22.725C16.7083 22.2417 17.3 22 18 22C18.7 22 19.2917 22.2417 19.775 22.725C20.2583 23.2083 20.5 23.8 20.5 24.5C20.5 25.2 20.2583 25.7917 19.775 26.275C19.2917 26.7583 18.7 27 18 27ZM12.35 21.35L10.25 19.2C11.2333 18.2167 12.3875 17.4375 13.7125 16.8625C15.0375 16.2875 16.4667 16 18 16C19.5333 16 20.9625 16.2917 22.2875 16.875C23.6125 17.4583 24.7667 18.25 25.75 19.25L23.65 21.35C22.9167 20.6167 22.0667 20.0417 21.1 19.625C20.1333 19.2083 19.1 19 18 19C16.9 19 15.8667 19.2083 14.9 19.625C13.9333 20.0417 13.0833 20.6167 12.35 21.35ZM8.1 17.1L6 15C7.53333 13.4333 9.325 12.2083 11.375 11.325C13.425 10.4417 15.6333 10 18 10C20.3667 10 22.575 10.4417 24.625 11.325C26.675 12.2083 28.4667 13.4333 30 15L27.9 17.1C26.6167 15.8167 25.1292 14.8125 23.4375 14.0875C21.7458 13.3625 19.9333 13 18 13C16.0667 13 14.2542 13.3625 12.5625 14.0875C10.8708 14.8125 9.38333 15.8167 8.1 17.1Z",
    fill: "#155724"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/Online.5e09907a555a9d0a57aec870b4914fbd.svg";
export { ForwardRef as ReactComponent };